<template lang="pug">
.promotion-explained-stamp
  .promotion-item.flex.aic(v-if="variant && promotion")
    .type.flex.aic
      template {{ promotion.promotion_type | promotionType }} Promotion
      help-tag(
        v-if="promotion.promotion_type === PROMOTION_TYPES.TPR || promotion.promotion_type === SHORT_PROMOTION_TYPES.TPR"
        :tooltip="promotion.promotion_type | promotionTypeHelpText")
    .info
      .applied(v-if="promotion.promo_action_type !== PROMOTION_ACTIONS_TYPES.STACKED")
        span.discounted(v-if="promotion.discount_type === 'Fix rate' && promotion.promotion_actions[0]")
          strong.value -{{ promotion.promotion_actions[0].discount_value | cents }}
          | /case
        span.discounted(v-else-if="promotion.discount_type === 'Percentage' && promotion.promotion_actions[0]") {{ promotion.promotion_actions[0].discount_value | percentage }} off
        span.divider
        span.new-price Only&nbsp;
          strong.value {{ variant.case_price_cents | promotion-price(promotion) }}
          | /case

      .case-minimum(v-if="promotion.minimum_num_case > 1")
        small Applicable with a minimum purchase of&nbsp;
          strong.value {{ promotion.minimum_num_case | number }}
          | &nbsp;cases

      .expiry-date(v-if="promotion.promotion_type === SHORT_PROMOTION_TYPES.SHORT_DATE")
        small This is a short-dated promotion. SKU expiry date:&nbsp;
          strong.value {{ promotion.sku_expiry_date | date }}

      .case-limit(v-if="promotion.case_limit")
        template(v-if="promotion.promotion_type === SHORT_PROMOTION_TYPES.BUY_IN")
          small Limited to first&nbsp;
            strong.value {{ promotion.case_limit | number }}
            | &nbsp;case{{ promotion.case_limit > 1 ? 's' : '' }} of the first order

        template(v-else)
          small Limited to first&nbsp;
            strong.value {{ promotion.case_limit | number }}
            | &nbsp;case{{ promotion.case_limit > 1 ? 's' : '' }} only

      CaseStackPromotions(:promotion="promotion")

</template>

<script>
import PriceChangeStamp from '~/components/stamps/PriceChangeStamp'
import CaseStackPromotions from '~/components/promotions/CaseStackPromotions'
import { PROMOTION_TYPES, SHORT_PROMOTION_TYPES, PROMOTION_ACTIONS_TYPES } from '~/settings'

export default {
  components: {
    PriceChangeStamp,
    CaseStackPromotions
  },

  props: {
    product: {
      type: Object,
      required: true
    },

    variant: {
      type: Object,
      default: null
    },

    quantity: {
      type: Number,
      default: 1
    }
  },

  data () {
    return {
      PROMOTION_TYPES,
      SHORT_PROMOTION_TYPES,
      PROMOTION_ACTIONS_TYPES
    }
  },

  computed: {
    promotions () {
      if (!this.variant) return []
      return this.variant.promotions || []
    },

    promotion () {
      return this.promotions.length ? this.promotions[0] || null : null
    }
  }
}
</script>

<style lang="scss" scoped>
.promotion-explained-stamp {
  line-height: 140%;
  .promotion-item {
    background-color: #FFF7DF;
    font-size: 12px;
    padding: 1em;
    border-radius: $--radius;
    gap: 8px;
    .type {
      font-weight: $--font-weight-bold;
      color: #FBB122;
      text-transform: uppercase;
      flex: 0 180px;
    }
    .info {
      flex: 1;
      .divider {
        &:after {
          content: '-';
          margin: 0 .5em;
        }
      }
      small {
        font-size: 12px;
      }
    }
  }
}
</style>
